import { render, staticRenderFns } from "./PrijavaEdit.vue?vue&type=template&id=38ccb7fe&scoped=true&"
import script from "./PrijavaEdit.vue?vue&type=script&lang=js&"
export * from "./PrijavaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ccb7fe",
  null
  
)

export default component.exports